const toggle = document.getElementById('hamburger-toggle');
const menu = document.getElementById('hamburger-menu');

if (toggle && menu) {
	toggle.addEventListener('click', () => {
		const isOpen = toggle.getAttribute('aria-expanded') === 'true';
		toggle.setAttribute('aria-expanded', !isOpen);
		menu.classList.toggle('is-open', !isOpen);
	});

	menu.querySelectorAll('.hamburger-nav__link').forEach((link) => {
		link.addEventListener('click', (e) => {
			const href = link.getAttribute('href') || '';
			if (href.startsWith('#')) {
				e.preventDefault();
				const target = document.querySelector(href);
				if (target) {
					target.scrollIntoView({ behavior: 'smooth' });
				}
			}
			toggle.setAttribute('aria-expanded', 'false');
			menu.classList.remove('is-open');
		});
	});

	document.addEventListener('click', (e) => {
		if (!toggle.contains(e.target) && !menu.contains(e.target)) {
			toggle.setAttribute('aria-expanded', 'false');
			menu.classList.remove('is-open');
		}
	});
}
